export enum DocType {
    'ADHAR' = 'ADHAR',
    'PANCR' = 'PANCR',
    'DRVLC' = 'DRVLC',
    'VTRID' = 'VTRID',
    'PSPRT' = 'PSPRT',
}
